'use client'
import { Col, CopyButton, Row, Typography } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import { useGetAgentReferralCodes } from '@repo/services'
import { globalConfig } from '@repo/shared/utils'
import { ShareInline } from '@repo/shared'

export const DashboardReferral = () => {
  const { t } = useTranslate()
  const { data } = useGetAgentReferralCodes()
  const referralCode = data?.data?.codes?.[0]?.code
  const shareUrl = `${globalConfig.originWebUrl}/aff/${referralCode}`
  const shareText = t('dashboardAgent_share_text', {
    url: shareUrl,
  })

  return (
    <div className='flex flex-col gap-md  md:flex-row  bg-base-radial-gradient  rounded-md border-4 border-base-main-20 w-full'>
      <Col className=' p-6 w-full gap-md mx-auto rounded-md'>
        <Typography size='sm' color='text-base-main-100'>
          {t('dashboardAgent_referral_link_title')}
        </Typography>

        <Row className='bg-base-main-100/10 backdrop-blur-sm rounded-xs p-2xs'>
          <Row className='flex items-center justify-between gap-2'>
            <CopyButton
              text={`${shareUrl}`}
              nonActiveTitle={t('common_copy')}
              activeMessageTitle={t('common_copied')}
            />

            <Typography
              size='sm'
              color='text-base-main-100'
              className='ltr px-2xs'
            >
              {globalConfig.originWebUrl?.replace('https://', '')}/aff/
              {referralCode}
            </Typography>
          </Row>
        </Row>
        <Row className='justify-between items-center'>
          <Typography size='2xs' color='text-base-main-80'>
            {t('dashboardAgent_shareOn')}
          </Typography>
          <ShareInline
            url={shareUrl}
            text={shareText}
            iconSize='xs'
            iconColor='fill-base-main-100'
          />
        </Row>
      </Col>
      <Col className=' p-6 w-full gap-md mx-auto rounded-md'>
        <Typography size='sm' color='text-base-main-100'>
          {t('dashboardAgent_referral_code_title')}
        </Typography>

        <Row className='bg-base-main-100/10 backdrop-blur-sm rounded-xs p-2xs'>
          <Row className='flex items-center justify-between gap-2'>
            <CopyButton
              text={`${referralCode}`}
              nonActiveTitle={t('common_copy')}
              activeMessageTitle={t('common_copied')}
            />

            <Typography
              size='sm'
              color='text-base-main-100'
              className='ltr px-2xs'
            >
              {referralCode}
            </Typography>
          </Row>
        </Row>
      </Col>
    </div>
  )
}
